export default "__VITE_ASSET__DDwQ0Dr9__"